import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Code2, Sparkles } from 'lucide-react';

const Hero = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToWork = () => {
    document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      className="hero-section-aesthetic" 
      id="hero"
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Background Image with Overlay */}
      <div className="hero-bg-wrapper">
        <img 
          src="https://customer-assets.emergentagent.com/job_dev-duo-studio/artifacts/yuxns4t6_24e65e414d802e36dbe2b616429d7751.jpg"
          alt="Developer workspace"
          className="hero-bg-image"
        />
        <div className="hero-bg-overlay"></div>
        <div className="hero-bg-gradient"></div>
      </div>
      
      {/* Dynamic Cursor Glow */}
      <div 
        className="hero-cursor-glow"
        style={{
          position: 'absolute',
          left: `${mousePosition.x}px`,
          top: `${mousePosition.y}px`,
          width: '550px',
          height: '550px',
          background: 'radial-gradient(circle, rgba(255, 255, 255, 0.12) 0%, transparent 60%)',
          borderRadius: '50%',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          zIndex: 1,
          mixBlendMode: 'screen',
          transition: 'opacity 0.4s ease',
          opacity: isHovering ? 1 : 0
        }}
      />

      {/* Content */}
      <div className="hero-content-aesthetic">
        <div className="hero-content-inner">
          {/* Badge */}
          <div className="hero-badge-aesthetic">
            <Sparkles className="badge-icon-aesthetic" />
            <span>Creative-First Web Design</span>
          </div>

          {/* Main Title */}
          <h1 className="hero-title-aesthetic">
            <span className="title-word">Building</span>
            <span className="title-word accent">
              Digital
              <span className="digital-underline"></span>
            </span>
            <span className="title-word">Masterpieces</span>
          </h1>

          {/* Subtitle */}
          <p className="hero-subtitle-aesthetic">
            We don't just code websites—we craft experiences. Medhansh & Raghav, 
            two young creative directors who blend AI, intuition, and visual storytelling 
            to build websites that captivate and convert.
          </p>

          {/* Stats Row */}
          <div className="hero-stats-aesthetic">
            <div className="stat-aesthetic">
              <Code2 className="stat-icon-aesthetic" />
              <div className="stat-content">
                <div className="stat-number-aesthetic">Fast</div>
                <div className="stat-label-aesthetic">Execution</div>
              </div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-aesthetic">
              <div className="stat-content">
                <div className="stat-number-aesthetic">100%</div>
                <div className="stat-label-aesthetic">Collaborative</div>
              </div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-aesthetic">
              <div className="stat-content">
                <div className="stat-number-aesthetic">AI+</div>
                <div className="stat-label-aesthetic">Creative</div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="hero-cta-aesthetic">
            <Button 
              className="btn-aesthetic-primary" 
              onClick={scrollToContact}
            >
              Start Your Project
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              className="btn-aesthetic-secondary" 
              onClick={scrollToWork}
            >
              View Our Work
            </Button>
          </div>

          {/* Scroll Indicator */}
          <div className="scroll-indicator">
            <div className="scroll-line"></div>
            <span className="scroll-text">Scroll to explore</span>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="hero-decor-grid"></div>
    </section>
  );
};

export default Hero;
